import React, { useCallback, useMemo } from 'react';
import { duplicateItems } from '../state/actions/duplicate-items';
import {
  useSelectedItems,
  useTracks,
  useWriteContext,
} from '../utils/use-context';
import { useTranslations } from 'next-intl';
import { ToolButton } from '@crabs-ai/ds-react';
import { ContentCopy } from '@crabs-ai/web-icons';

export function DuplicateItemTool() {
  const t = useTranslations();
  const { selectedItems } = useSelectedItems();
  const { setState } = useWriteContext();
  const { tracks } = useTracks();

  const duplicatableItems = useMemo(() => {
    if (selectedItems.length === 0) return [];
    return selectedItems.filter((itemId) => {
      const track = tracks.find((t) => t.items.includes(itemId));
      return !track?.locked;
    });
  }, [selectedItems, tracks]);

  const canDuplicate = duplicatableItems.length > 0;

  const handleDuplicate = useCallback(() => {
    if (!canDuplicate) return;
    setState({
      update: (state) => {
        const stateTracks = state.undoableState.tracks;
        const stateSelectedItems = state.selectedItems;
        const duplicatable = stateSelectedItems.filter((itemId) => {
          const track = stateTracks.find((t) => t.items.includes(itemId));
          return !track?.locked;
        });
        if (duplicatable.length === 0) return state;
        return duplicateItems(state, duplicatable);
      },
      commitToUndoStack: true,
    });
  }, [canDuplicate, setState]);

  return (
    <ToolButton
      size="sm"
      isTransparent={false}
      state={!canDuplicate ? 'disabled' : 'default'}
      onClick={handleDuplicate}
      disabled={!canDuplicate}
      isShowTooltip
      tooltipNode={t('Editor.timeline-controls.duplicate')}
      tooltipSubNode="[⌘/Ctrl+D]"
      tooltipPosition="top"
    >
      <ContentCopy className="size-5" />
    </ToolButton>
  );
}
